import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IDeletePageDraftPayload } from '../../../action/page.action';
import { DesignObjectModel } from '../../../model/design-object.model';

export const deleteDesignObjectDraft = (design: DesignObjectModel | string, shouldRevert: boolean = true) => returnAction<IDeletePageDraftPayload>(ActionEnum.DELETE_DESIGN_DRAFT, {
  design, shouldRevert
});
